<div class="button-bar">
    <clx-button
        [type]="enableUITwo? 'default' : 'icon'"
        title="Refresh"
        i18n-title="@@webaccess.button.refresh"
        uiTwoIcon="simpl-icon-refresh"
        [ngClass]="enableUITwo? 'secondary-button' : 'small icon fa-refresh fa io'"
        i18n="@@webaccess.button.refresh.text"
        (onClick)="refresh()"> </clx-button>
    <clx-button
        [type]="enableUITwo? 'default' : 'icon'"
        title="Open in new tab"
        i18n-title="@@webaccess.button.openinnewtab"
        uiTwoIcon="simpl-icon-export"
        [ngClass]="enableUITwo? 'secondary-button' : 'small icon fa-external-link fa io'"
        (onClick)="openInNewTab()"
        i18n="@@webaccess.button.openinnewtab.text"
    > </clx-button>
</div>
<iframe [attr.src]="launchWebAccessUrl" style="width: 100%; height: 620px; border: 0 none"></iframe>